import React from 'react'
import { HeroBtnRoute, HeroBtnWrap, HeroImg, HeroSectionContainer,IntroText,SubText,SubTextWrap } from './HeroSectionElements'
import img from "../../assets/hero_section_idea.svg";
export default function HeroSection() {
  return (
    <HeroSectionContainer>
        <HeroImg src={img}/>
        <IntroText>Your All new Social App</IntroText>
        <SubTextWrap>
            <SubText>Add Friends</SubText>
            <SubText>Chat</SubText>
            <SubText>Express</SubText>
        </SubTextWrap>
        <HeroBtnWrap>
                <HeroBtnRoute to='/register'>Join Now</HeroBtnRoute>
        </HeroBtnWrap>
    </HeroSectionContainer>
  )
}
